import React from 'react';
import {
  Home,
  FileText,
  Users,
  Users2,
  Search,
  ExternalLink,
  Calendar,
  Activity,
  Bell,
  MessageSquareText,
  MapPin,
} from 'lucide-react';

export interface NavigationItem {
  label: string;
  to: string;
  icon: React.ReactNode;
  description?: string;
  badge?: string;
  external?: boolean;
}

export const primaryNavItems: NavigationItem[] = [
  {
    label: 'Home',
    to: '/',
    icon: React.createElement(Home, { className: 'w-5 h-5' }),
    description: 'Dashboard and overview',
  },
  {
    label: 'Search',
    to: '/search',
    icon: React.createElement(Search, { className: 'w-5 h-5' }),
    description: 'Find bills and legislators',
  },
  {
    label: 'Bills',
    to: '/bills',
    icon: React.createElement(FileText, { className: 'w-5 h-5' }),
    description: 'Legislative tracking',
  },
  {
    label: 'Legislators',
    to: '/legislators',
    icon: React.createElement(Users, { className: 'w-5 h-5' }),
    description: 'Representative profiles',
  },
  {
    label: 'Committees',
    to: '/committees',
    icon: React.createElement(Users2, { className: 'w-5 h-5' }),
    description: 'Committee information',
  },
  {
    label: 'Calendar',
    to: '/calendar',
    icon: React.createElement(Calendar, { className: 'w-5 h-5' }),
    description: 'Meetings and floor calendars',
  },
  {
    label: 'Testimony',
    to: '/testimony',
    icon: React.createElement(MessageSquareText, { className: 'w-5 h-5' }),
    description: 'Public testimony on bills',
  },
  {
    label: 'Find Your Legislator',
    to: '/tools/find-your-legislator',
    icon: React.createElement(MapPin, { className: 'w-5 h-5' }),
    description: 'Look up your representatives',
  },
];

export const adminNavItems: NavigationItem[] = [
  {
    label: 'Pipeline',
    to: '/admin/pipeline',
    icon: React.createElement(Activity, { className: 'w-5 h-5' }),
    description: 'Job queue and scraper status',
  },
  {
    label: 'Schedules',
    to: '/admin/schedules',
    icon: React.createElement(Calendar, { className: 'w-5 h-5' }),
    description: 'Automated job scheduling',
  },
  {
    label: 'Bill Status',
    to: '/admin/bill-status',
    icon: React.createElement(FileText, { className: 'w-5 h-5' }),
    description: 'Pipeline processing status',
  },
  {
    label: 'Notifications',
    to: '/admin/notifications',
    icon: React.createElement(Bell, { className: 'w-5 h-5' }),
    description: 'Email alerts and testing',
  },
  {
    label: 'Topeka Buzz',
    to: '/admin/topeka-buzz',
    icon: React.createElement(FileText, { className: 'w-5 h-5' }),
    description: 'Combined newsletter content',
  },
  {
    label: 'Reports',
    to: '/admin/reports',
    icon: React.createElement(FileText, { className: 'w-5 h-5' }),
    description: 'Newsletter content generator',
  },
];

export const externalLinks: NavigationItem[] = [
  {
    label: 'Capitol Bee',
    to: 'https://capitolbee.com',
    icon: React.createElement(ExternalLink, { className: 'w-5 h-5' }),
    description: 'External legislative resource',
    external: true,
  },
];
